import SectionStructure from '../../../../components/Section/SectionStructure';
import MonitoringText from './MonitoringText';
import CvdButtonGroup from './CvdButtonGroup'
import Grid from '@mui/material/Grid';
import HeartCard from './MonitoringCards/HeartAge/HeartCard'
import RhythmCard from './MonitoringCards/HeartRhythm/RhythmCard'



export default function SectionMonitoring() {

    
    return (

        <SectionStructure
    
        sectiontext=    { <MonitoringText /> }
        sectiondiagroup=    { <CvdButtonGroup />} 

        sectioncards=  {<>

            <Grid container>
                    <Grid > <HeartCard />  </Grid>
                    <Grid > <RhythmCard />  </Grid>
        </Grid>
    </>}
/>
)
}
